module.exports = __webpack_public_path__ + "img/logoos.a93724bb.svg";